/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 13.06.2016
 *
 */

import { FormActions, RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import MapConfigWebApi from '../webapi/MapConfigWebApi';
import ClassNames from '../constants/ClassNames';

const className = ClassNames.MapConfig;

export default {

    allList: (name) => RemoteDataActions.list(name, className),
    allGroupedList: (name) => RemoteDataActions.list(name, className, {}, MapConfigWebApi.allListViewableMapConfigs),

    item: (name, query) => RemoteDataActions.item(name, className, query),
    itemDefaultGrouped: (name, query) => RemoteDataActions.item(name, className, query, MapConfigWebApi.itemDefaultGrouped),
    // moreItems: (name, query) => RemoteDataActions.moreItems(name, className, query),

    updateMapConfig: (item, formId, closeForm) => {
        FormActions.submitForm(MapConfigWebApi.updateMapConfig, item, formId, closeForm);
    },

    addMapConfig: (item, formId, closeForm) => {
        FormActions.submitForm(MapConfigWebApi.addMapConfig, item, formId, closeForm);
    },

    deleteMapConfig: (item, formId, closeForm) => {
        FormActions.submitForm(MapConfigWebApi.deleteMapConfig, item, formId, closeForm);
    },

    setDefaultMapConfig: (item, formId, closeForm) => {
        FormActions.submitForm(MapConfigWebApi.setDefaultMapConfig, item, formId, closeForm);
    },

    resetDefaultMapConfig: (item, formId, closeForm) => {
        FormActions.submitForm(MapConfigWebApi.resetDefaultMapConfig, item, formId, closeForm);
    }

};



// WEBPACK FOOTER //
// ./js/actions/MapConfigActions.js